
@if (loading) {
  <mat-progress-spinner mode="indeterminate" [diameter]="30" class='spin'> </mat-progress-spinner>
}

<div class="ident-link">

  <p>
    <span>
      Individual Identification link<br>
      <button mat-button [cdkCopyToClipboard]="'https://bodyof9.com/product/individual-identification'"><mat-icon >content_copy</mat-icon>COPY</button>
      <a href="https://bodyof9.com/product/individual-identification" target="_blank">GO TO<mat-icon >shortcut</mat-icon></a>
    </span> &nbsp;
    <span>
      Family Identification link<br>
      <button mat-button [cdkCopyToClipboard]="'https://bodyof9.com/product/parenting-session'"><mat-icon >content_copy</mat-icon>COPY</button>
      <a href="https://bodyof9.com/product/parenting-session" target="_blank">GO TO<mat-icon >shortcut</mat-icon></a>
    </span> &nbsp;
    <span>
      Couple Identification link<br>
      <button mat-button [cdkCopyToClipboard]="'https://bodyof9.com/product/couples-identification'"><mat-icon >content_copy</mat-icon>COPY</button>
      <a href="https://bodyof9.com/product/couples-identification" target="_blank">GO TO<mat-icon >shortcut</mat-icon></a>
    </span>

  </p>

  <p>


    <button mat-button [cdkCopyToClipboard]="couponCode"><mat-icon >content_copy</mat-icon>COPY</button>
    @if (couponCode) {
      <span>&nbsp; <b>YOUR Coupon Code: </b> &nbsp; {{ couponCode }}</span>
    }

    @if (isAdmin()) {
      <span>&nbsp; <button mat-button (click)="addCouponCode()"> Add Coupon Code </button></span>
    }

  </p>

</div>



<div class="action">
  @if (prepaidCount > 0 || client) {
    <div>
      <button type="button" (click)="onClickInvite()">
        @if (client) {
          <span>Invite Client</span>
        }
        @if (!client) {
          <span>Click to Assign PrePaid Identification</span>
        }
        <mat-icon>how_to_reg</mat-icon>
      </button>
    </div>
  }

  @if (isAdmin() && client) {
    <span>
      <button type="button" (click)="onClickAdd(inputGroup)" >
        @if (client) {
          <span>Add Client</span>
          } <mat-icon>add</mat-icon>
        </button>
      </span>
    }

  </div>

  @if (editing && client) {
    <div class='editing'>
      <button class='close' mat-stroked-button (click)="onCloseClick()">Close <mat-icon>close</mat-icon></button>
      <client-member-form [inputGroup]="inputGroup" (notifyParent)="memberSubmittedHandler($event)" ></client-member-form>
    </div>
  }

  @if (editing && !client) {
    <div class='editing'>
      <button class='close' mat-stroked-button (click)="onCloseClick()">Close <mat-icon>close</mat-icon></button>
      <prepaid-member-form [person]="person" [members]="members" [inputGroup]="inputGroup" [canMEA]="canMEA" [packages]="packages" (notifyParent)="memberSubmittedHandler($event)" ></prepaid-member-form>
    </div>
  }

  @if (inputGroup && inputGroup.members.length > 0) {
    <div>
      <p>After you have purchased your pre-paid Identification you can assign it to your client here.
        After assigning the name and email below an email will be sent to your client directly from Body of 9 with instruction on how to book their Identification
      and invite you to attend.</p>
      @if (client) {
        <span><h2>Clients of: {{ inputGroup?.group.groupName }}</h2></span>
      }
      @if (!client) {
        <span><h2>List of: {{ inputGroup?.group.groupName }}</h2></span>
      }
      <span>
        <button mat-stroked-button (click)="onRefreshClick()">Refresh <mat-icon>refresh</mat-icon></button>
      </span>
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
          <td mat-cell *matCellDef="let element"> {{element.formPerson.firstName}} {{element.formPerson.lastName}} </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
          <td mat-cell *matCellDef="let element"> {{ element.invitedStatus }}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
          <td mat-cell *matCellDef="let element"> {{ element.person.primaryEmail }}</td>
        </ng-container>
        <ng-container matColumnDef="nn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nat. Num. </th>
          <td mat-cell *matCellDef="let element"> {{ element.formPerson.naturalNumber}}</td>
        </ng-container>
        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Booking Link </th>
          <td mat-cell *matCellDef="let element"> @if (!element.eventParams?.unassignedDate && !element.eventParams?.usedDate) {
            <span>
              <button mat-button [cdkCopyToClipboard]="element.invitedPerson.link"><mat-icon >content_copy</mat-icon>Copy</button><a href="element.invitedPerson.link">Booking Link</a></span>
            } @else {
              N/A
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="calendly">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Calendy </th>
          <td mat-cell *matCellDef="let element">
            @if (element.formPerson.naturalNumber==0) {
              <span>
                @if (element.formPerson.idLink) {
                  <span>
                    <button mat-button [cdkCopyToClipboard]="element.formPerson.idLink"><mat-icon >content_copy</mat-icon></button><a href="element.formPerson.idLink">Booking Link</a>
                  </span>
                } @else {
                  Use Links above
                }
              </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="revoke">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Revoke </th>
          <td mat-cell *matCellDef="let element">
            @if (!element.eventParams?.unassignedDate && !element.eventParams?.usedDate) {
              <span><button type="button" (click)="onClickRevoke(element)"> <mat-icon>remove_done</mat-icon></button></span>
            }
            @if (element.eventParams?.usedDate) {
              <span> Used </span>
            }
            @if (element.eventParams?.unassignedDate) {
              <span> Revoked </span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Remove </th>
          <td mat-cell *matCellDef="let element">
            @if (!(element.person._key == inputGroup.createdBy)) {
              <span><button type="button" (click)="onClickLeave(element)"> <mat-icon>logout</mat-icon></button></span>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 15, 20, 50, 100]" (page)="onChangePage($event)"></mat-paginator>
    </div>
  }
